import { supabase } from "../../../supabaseClient";

export async function fetchEventFees(eventIds) {
  if (!eventIds || eventIds.length === 0) return [];

  const { data, error } = await supabase
    .from("eventFee")
    .select("eventsID")
    .in("eventsID", eventIds);

  if (error) throw error;

  return data;
}
